const estadosPendientes = new Set(['pendiente', 'sincronizando', 'conflicto']);

export function pendientesDelTurno(ventas, turnoId) {
  // Los comprobantes antiguos sin turno conocido necesitan revisión antes del cierre.
  return ventas.filter(v => estadosPendientes.has(v.estado) &&
    (v.turno_id_origen == null || Number(v.turno_id_origen) === Number(turnoId)));
}

export function respaldoVentasPendientes(ventas) {
  // Copia para conciliación; excluye payloads que pueden contener autorización del supervisor.
  return {
    formato: 'casa-alessio-ventas-pendientes-v1',
    exportado_en: new Date().toISOString(),
    ventas: ventas.filter(v => estadosPendientes.has(v.estado)).map(v => ({
      idempotency_key: v.idempotency_key, turno_id_origen: v.turno_id_origen ?? null,
      empresa_id: v.empresa_id, sucursal_id: v.sucursal_id, deposito_id: v.deposito_id,
      usuario_id: v.usuario_id, dispositivo_id: v.dispositivo_id, secuencia: v.secuencia,
      creada_en: v.creada_en, estado: v.estado, error: v.error,
      cliente_id: v.payload?.cliente_id ?? null, cliente_nombre: v.cliente_nombre,
      total: v.preview?.total_final,
      metodo_pago: v.payload?.metodo_pago,
      pagos: (v.payload?.pagos || []).map(p => ({ metodo_pago: p.metodo_pago, monto: p.monto })),
      productos: (v.payload?.productos || []).map(p => p.es_manual
        ? { es_manual: true, descripcion_manual: p.descripcion_manual, precio_manual: p.precio_manual, cantidad: p.cantidad }
        : { producto_id: p.producto_id, cantidad: p.cantidad }),
    })),
  };
}
